import { render, staticRenderFns } from "./CalendarDetail.vue?vue&type=template&id=6afe0024&scoped=true&"
import script from "./CalendarDetail.vue?vue&type=script&lang=js&"
export * from "./CalendarDetail.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDetail.vue?vue&type=style&index=0&id=6afe0024&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afe0024",
  null
  
)

export default component.exports